import { FileReferences } from "@/components/features/matter/file-repo/FileReferences";
import { AppModal } from "@/components/ui";
import type { Matter, MatterSubItemType } from "@/lib/types";
import {
  matterFileReferenceParentIdFieldBySubItemType,
  mergeFilesAndReferenceId,
} from "@/lib/utils/matterFile";
import { useMemo } from "react";

interface MatterSubItemFileReferencesModalProps {
  createFileReferenceOpen: boolean;
  entityLabel: string;
  matter: Matter;
  onCreateFileReferenceOpenChange: (open: boolean) => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  subItem: {
    id: string;
    type: MatterSubItemType;
  };
}

export const MatterSubItemFileReferencesModal = ({
  createFileReferenceOpen,
  entityLabel,
  matter,
  onCreateFileReferenceOpenChange,
  onOpenChange,
  open,
  subItem,
}: MatterSubItemFileReferencesModalProps) => {
  const files = useMemo(() => {
    const parentIdField =
      matterFileReferenceParentIdFieldBySubItemType[subItem.type];
    return parentIdField
      ? mergeFilesAndReferenceId(matter, parentIdField, subItem.id)
      : [];
  }, [matter, subItem]);

  return (
    <AppModal
      open={open}
      onOpenChange={onOpenChange}
      title={`File references for ${entityLabel}`}
      size="2xl"
      bodyContained
    >
      <div className="h-[min(80vh,52rem)] min-h-0 overflow-y-auto">
        <FileReferences
          files={files}
          matter={matter}
          subItem={subItem}
          createFileReferenceOpen={createFileReferenceOpen}
          onCreateFileReferenceOpenChange={onCreateFileReferenceOpenChange}
        />
      </div>
    </AppModal>
  );
};
